export const generateCsrfTokenHeadersFrom = (values = {}) => ({
  'x-csrf-token': values.csrf
})

export const csrfToken = (state) => {
  const { authData = {} } = state.auth;
  return authData.csrf
}

export default (state) => {
  const { authData = {} } = state.auth;
  return generateCsrfTokenHeadersFrom(authData)
};

